import React from 'react';
import { Link } from 'react-router-dom';
import { buildSignupPath, buildSignupState, captureCtaClick } from '../utils/analytics';

function HeroSection() {
  return (
    <section className="bg-white relative overflow-hidden">

      {/* Ambient background glow */}
      <div className="absolute top-[-200px] left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full bg-gradient-to-br from-blue-100/60 via-purple-50/40 to-transparent blur-3xl ambient-glow pointer-events-none" />

      <div className="hero-animate relative z-10 flex flex-col items-center text-center px-8 md:px-16 pt-20 pb-20 md:pt-28 md:pb-28 max-w-[1440px] mx-auto w-full">

        {/* Headline */}
        <h1 className="text-5xl md:text-6xl xl:text-[76px] xl:leading-[1.04] text-[#1d1d1f] leading-tight tracking-tight max-w-[900px]">
          Streamline Your{' '}
          <span className="gradient-text">Prescription</span>{' '}
          Process
        </h1>

        {/* Subtext */}
        <p className="mt-7 text-xl md:text-[22px] text-[#6e6e73] max-w-xl leading-relaxed font-normal">
          Make medications accessible and affordable for all.
        </p>

        {/* CTA buttons */}
        <div className="flex items-center gap-5 mt-14">
          <Link
            to={buildSignupPath()}
            state={buildSignupState('hero-get-started')}
            data-ph-capture-attribute-cta="hero-get-started"
            onClick={() => captureCtaClick('hero-get-started', { placement: 'hero' })}
            className="bg-[#1d1d1f] px-8 py-[14px] text-[15px] text-white hover:bg-[#333] transition-all rounded-full whitespace-nowrap shadow-lg shadow-black/10 hover:shadow-xl hover:shadow-black/15 hover:-translate-y-[1px]"
          >
            Get Started
          </Link>
          <Link
            to={buildSignupPath()}
            state={buildSignupState('hero-book-demo')}
            data-ph-capture-attribute-cta="hero-book-demo"
            onClick={() => captureCtaClick('hero-book-demo', { placement: 'hero' })}
            className="px-8 py-[14px] text-[15px] text-[#06c] hover:text-[#004aad] transition-all whitespace-nowrap font-medium"
          >
            Book a Demo →
          </Link>
        </div>

      </div>
    </section>
  );
}

export default HeroSection;
